export default  {
  bindings: {
    treatment: '=',
    formTab: '=',
    activeDay: '&'
  },
  controller: 'treatmentFormController',
  template: require('../views/treatment.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/treatment/components/treatment.form.component.js